export const MODULE_NAME = 'globaltransactions'; //BaseApi

export const GLOBAL_TRANSACTIONS = 'globalTransactions';
export const SET_GLOBAL_TRANSACTIONS = 'setGlobalTransactions';
export const SET_RELOAD_TRANSACTIONS = 'setReloadTransactions';
export const RELOAD_TRANSACTIONS = 'reloadTransactions';
export const TOAST_MESSAGES_PUSH = 'toastMessages/push';
export const TRANSACTION_AUDIT_LOG = 'transactionAuditLog';
export const SET_TRANSACTION_AUDIT_LOG = 'setTransactionAuditLog';
export const SET_ALL_TRANSACTION_AUDIT_LOG = 'setAllTransactionAuditLog';
export const CLEAR_GLOBAL_TRANSACTIONS = 'clearGlobalTransactions';